import React, { useCallback, useState } from "react";
import { Divider, Modal, Space, Spin } from "antd";
import { setCustomerAvailabilityV2 } from "utils/api";
import { defaultNgiErrorMethod, successMessage } from "components/Common/responses/message";
import CustomButton from "components/Common/buttons/CustomButton";
import setAvaliabilityIcon from "assets/images/svg/setAvaliabilityIcon.svg";
import { makeStyles } from "@material-ui/core/styles";
import CalendarPicker from "pages/customer-management/customerDetails/CalendarPicker";

const useStyles = makeStyles({
  modalWrapper: {
    width: "400px!important",

    "&> .ant-modal-content .ant-modal-body": {
      padding: "0px 24px 24px !important",
    },
    "&> .ant-modal-content .ant-modal-header": {
      padding: "24px 24px 0 !important",
    },
  },
  descriptionTitle: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    fontWeight: 600,

    "&>span": {
      fontSize: 13,
      fontWeight: 300,
    },
  },
  withIcon: {
    display: "flex",
    alignItems: "center",

    "&>img": {
      marginRight: 10,
    },
  },
  notReachableBtn: {
    border: "2px solid #FF2E00",
    color: "#FF2E00",
  },
});
const SetAvailabilityModal = ({ customerId, onClose, update }) => {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const onSubmit = useCallback(
    e => {
      setDataLoading(true);
      const type = e.target.dataset.type;
      const { availableAt, timeSlot } = selectedDate || {};

      const data = {
        unreachable: type === "notReachable",
        availableAt,
        timeSlot,
      };
      setCustomerAvailabilityV2(customerId, data)
        .then(() => {
          setDataLoading(false);
          update();
          onClose();
          successMessage("The customer availability has been set successfully");
        })
        .catch(err => {
          setDataLoading(false);
          defaultNgiErrorMethod(err);
        });
    },
    [selectedDate]
  );

  return (
    <Modal
      title={
        <div className={classes.withIcon}>
          <img src={setAvaliabilityIcon} alt="" />
          <div className={classes.descriptionTitle}>
            Schedule Availability
            <span>Set the customer's availability, or mark as unreachable if you can't reach them.</span>
          </div>
        </div>
      }
      open
      onCancel={onClose}
      footer={[]}
      closable={false}
      className={classes.modalWrapper}
    >
      <Divider />
      <div>
        <Spin spinning={dataLoading}>
          <CalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
          <Divider />
          <Space>
            <CustomButton
              className={classes.notReachableBtn}
              onClick={onSubmit}
              data-type="notReachable"
              type="primary"
              size="small"
              color="outlined"
              text="NOT REACHABLE"
            />

            <CustomButton
              onClick={onSubmit}
              disabled={!selectedDate?.availableAt || !selectedDate?.timeSlot}
              data-type="schedule"
              htmlType="submit"
              type="primary"
              text="SCHEDULE"
              size="small"
            />
          </Space>
        </Spin>
      </div>
    </Modal>
  );
};

export default SetAvailabilityModal;
